import React from "react";
import { getAllSocialMediaImagePaths, loadSocialMediaIcon, socialMediaImagePathToUrl } from "../scripts/FileLoader";
import './../styles/ContactLine.css';
const ContactLine = function () {
    return React.createElement("div", { className: "contactLine" }, getAllSocialMediaImagePaths().map((iconFileName, index) => (React.createElement("a", { href: socialMediaImagePathToUrl(iconFileName), key: index },
        React.createElement("img", { className: "contactIcon", src: loadSocialMediaIcon(iconFileName) })))));
};
export default ContactLine;
